import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { FixedComponentsRateChart } from "./fixed-components-rate-chart-entity";
import { FixedComponentsCategoryEnum } from "@gtpl/shared-models/masters";
import { PackingCategoryEnum } from "@gtpl/shared-models/common-models";

@Entity('fixed_prices_chart_log')
export class FixedComponentsRateChartLogs{
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;

      @Column({
        type:"decimal",precision:10,scale:2,
        nullable: false,
        name: "old_price"
      })
       oldPrice: number; 

       @CreateDateColumn({
        name: "created_at",
        type: "datetime"
      })
      createdAt: Date;

      @Column({
        name: "effective_from",
        type: "datetime"
      })
      effectiveFrom: Date;

      @Column({
        type:'enum',
        nullable: false,
        name: "category",
        enum:FixedComponentsCategoryEnum
      })
      category: FixedComponentsCategoryEnum;
      
      
      @Column({
        type:'enum',
        nullable: false,
        name: "packing_category",
        enum:PackingCategoryEnum
      })
      PackingCategory: PackingCategoryEnum;
  
  @ManyToOne(type=>FixedComponentsRateChart, e=>e.logs,{  nullable:false, })
  @JoinColumn({ name:"ref_id"})
  RefId: FixedComponentsRateChart;
}